import '@vebox/etui-system';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { forwardRef, createElement } from 'react';
import { b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import '@vebox/etui-colors';
import '../ErrorLabel/ErrorLabel.js';
import '../FormItem/FormItem.js';
import '../Input/Input.js';
import '../InputLabel/InputLabel.js';
import TextInput from '../TextInput/TextInput.js';

const PhoneNumberInputField = /*#__PURE__*/forwardRef(function PhoneNumberInputField(props, ref) {
  return /*#__PURE__*/createElement(TextInput, _extends({}, props, {
    elRef: ref
  }));
});

export default PhoneNumberInputField;
